export function isTableRowActionEvent(event: MouseEvent): boolean {
  return !!(event.target as Element).closest('app-table-row-actions-button');
}
